export default "\r\n<app-sponsor-list></app-sponsor-list>\r\n\r\n\r\n";